
import { removeLocalStorage, ToLocalStorage } from "../../utils/localStorage";
import {
    LOGINLOADING,
    LOGINSUCCESS,
    LOGINERROR,
    SIGNOUTSUCCESS,
    MONEYLOADING,
    MONEYSUCCESS,
    MONEYERROR,
    MONEYFAILED,
    MONEYRESET,
    PROFILEUPDATERESET,
    PROFILEUPDATESUCCESS,
    PROFILEUPDATEFAILED
} from "../actionTypes";
import { SERVERBASEURL, server_url } from "../axios";
export const loginsuccess = user => {
    return {
        type: LOGINSUCCESS,
        payload: user
    }
}
export const loginerror = (err) => {
    return {
        type: LOGINERROR,
        payload: err
    }
}
export const loginloading = $ => {
    return {
        type: LOGINLOADING
    }
}
export const signoutsuccess = $ =>{
    return {
        type: SIGNOUTSUCCESS
    }
}


export const moneysuccess = $ => {
    return {
        type: MONEYSUCCESS,
    }
}
export const moneyerror = (err) => {
    return {
        type: MONEYERROR,
        payload: err
    }
}
export const moneyloading = $ => {
    return {
        type: MONEYLOADING
    }
}
export const moneyreset = $ => {
    return {
        type: MONEYRESET
    }
}
export const moneyfailed = payload => {
    return {
        type: MONEYFAILED,
        payload: payload
    }
}

export const profileupdatesuccess = payload => {
    return {
        type: PROFILEUPDATESUCCESS,
        payload: payload
    }
}
export const profileupdatefailed = payload => {
    return {
        type: PROFILEUPDATEFAILED,
        payload: payload
    }
}
export const profileupdatereset = $ => {
    return {
        type: PROFILEUPDATERESET
    }
}

export const signin = payload => async dispatch => {
    dispatch(loginloading())
    try {
        await server_url.post('/user/login', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user )
                dispatch(loginsuccess(res.data.user))
            })
    } catch (e) {
        dispatch(loginerror(e.response.data.message))
    };
}

export const createaccount = payload => async dispatch => {
    dispatch(loginloading())
    try {
        await server_url.post('/user/createaccount', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user )
                dispatch(loginsuccess(res.data.user))
            })
    } catch (e) {
        dispatch(loginerror(e.response.data.message))
    };
}

export const signout = $ => dispatch =>{
    removeLocalStorage("user")
    dispatch(signoutsuccess());
} 

export const updateUserProfile = payload => async dispatch => {
    dispatch(loginloading())
    try {
        await server_url.post('/user/updateProfile', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user )
                dispatch(profileupdatesuccess(res.data.user))
            })
    } catch (e) {
        dispatch(profileupdatefailed(e.response.data.message))
    };
}


export const addMoneyToUserAccount = payload => async dispatch => {
    dispatch(moneyloading())
    try {
        await server_url.post('/user/addfunds', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user )
                dispatch(moneysuccess(res.data.user))
            })
    } catch (e) {
        dispatch(moneyfailed(e.response.data.message))
    };
}



export const withdrawlMoneyToUserAccount = payload => async dispatch => {
    dispatch(moneyloading())
    try {
        await server_url.post('/user/withdrawlfunds', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user )
                dispatch(moneysuccess())
            })
    } catch (e) {
        dispatch(moneyfailed(e.response.data.message))
    };
}


export const getExpenditureFile = payload => async dispatch => {
    try {
        window.open(`${SERVERBASEURL}/user/expensesheet/${payload.clientId}`)
    } catch (e) {
         console.error(e.response)
        
    };
}

export const getOrderFile = payload => async dispatch => {
    try {
        window.open(`${SERVERBASEURL}/order/ordersheet/${payload}`)
    } catch (e) {
         console.error(e.response)    
    };
}


export const addDataToWatchlist = (payload, fn) => async dispatch => {
    try {
        await server_url.post('user/addwatchlist', {
                ...payload
            })
            .then(res => {
                ToLocalStorage("user", res.data.user);
                fn(res.data.user)
            })
    } catch (e) {
        console.error(e.response)
    };
}


export const removeDataFromWatchlist = (data, fn) => async dispatch => {
    try {
        await server_url.post('user/removewatchlist', {
                ...data
            })
            .then(res => {
                ToLocalStorage("user", res.data.user);
                fn(res.data.user)
            })
    } catch (e) {
        console.error(e.response)
    };
}




export const findUserHolding = (id, setHolding, setMap) => async dispatch => {
    try {
        var data = [];
        var defaultPrice = [];
        await server_url.get(`user/holding/${id}`)
            .then(res => {
                setHolding(res.data.holdings);
                res.data.holdings.forEach(el => {
                    data.push(el.instrument);
                    defaultPrice.push(el.price)
                });
            })
            .then($ => fetchMarketDataWithArray(data, setMap, defaultPrice))
    } catch (e) {
        console.error(e.response)
    };
}
export const fetchMarketDataWithArray = async (array, setMap, defaultPrice) => {
    const map = new Map();
    const arrayToStr = array.join(",")
    try {
        await server_url.get(`nse/get_multiple_quote_info?companyNames=${arrayToStr}`)
            .then(res => {
                if (res.data.status === "Not Avalaible") {
                    array.forEach((el, i) => map.set(el, defaultPrice[i]))
                    setMap(map)
                } else {
                    res.data.forEach(el => map.set(el.data[0].symbol, +(parseFloat(el.data[0].lastPrice.replace(/,/g, '')))))
                    setMap(map)
                }
            })
    } catch (e) {
        console.error(e.response)
    };
}



export const findUserOrders = (id, setOrder) => async dispatch => {
    try {
        await server_url.get(`order/${id}`)
            .then(res => {
                setOrder(res.data.order);
            })
    } catch (e) {
        console.error(e.response)
    };
}

